import { targetClasses } from 'src/js/modules/element-settings/constants/target-classes';

const gapDefaults = {
  [targetClasses.COLS_GAP_X]: '30px',
  [targetClasses.GAP_Y]: '48px',
};

export default gapDefaults;
